import * as React from "react";
import styled from "styled-components";
import { Icon, LinkContainer } from "components/common";
import { Badge, Nav } from "components/bootstrap";
import useNotificationBadgeCount from "components/notifications/hooks/useNotificationBadgeCount";
import { STATUS_LABELS } from "components/health/healthStatusCopy";
import { useHealthSummary } from "components/health/useHealthModule";
import useHealthModuleVisible, { HEALTH_QUERY_PARAM, HEALTH_ON_VALUE } from "components/health/useHealthModuleVisible";
import usePermissions from "hooks/usePermissions";
import usePluggableLicenseCheck from "hooks/usePluggableLicenseCheck";
import Routes from "routing/Routes";
import { NAV_ITEM_HEIGHT } from "theme/constants";
import InactiveNavItem from "./InactiveNavItem";
const STATUS_TO_BS_STYLE = {
  healthy: "success",
  warning: "warning",
  critical: "danger",
  unknown: "default"
};
const STATUS_TO_ICON = {
  healthy: "check_circle",
  warning: "warning",
  critical: "error",
  unknown: "help"
};
const StyledNav = styled(Nav)`
  > li > a {
    min-height: ${NAV_ITEM_HEIGHT};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
  }
`;
const StyledInactiveNavItem = styled(InactiveNavItem)`
  a:hover {
    border: 0;
    text-decoration: none;
  }
`;
const BadgeIcon = styled(Icon)`
  margin-right: 4px;
  margin-bottom: 2px;
`;
const StyledBadge = styled(Badge)`
  cursor: pointer;
`;
const HealthStatusBadge = () => {
  const { data: { valid: hasEnterpriseLicense } = { valid: false } } = usePluggableLicenseCheck("/license/enterprise");
  const showHealthModule = useHealthModuleVisible();
  const { overallStatus } = useHealthSummary();
  const { isPermitted } = usePermissions();
  const canReadNotifications = isPermitted("notifications:read");
  const { data: notificationCount } = useNotificationBadgeCount({ enabled: canReadNotifications });
  if (!hasEnterpriseLicense || !showHealthModule) return null;
  const statusLabel = STATUS_LABELS[overallStatus];
  const overviewWithHealthOn = `${Routes.SYSTEM.OVERVIEW}?${HEALTH_QUERY_PARAM}=${HEALTH_ON_VALUE}`;
  const accessibleLabel = notificationCount > 0 ? `Cluster health: ${statusLabel}, ${notificationCount} system notifications` : `Cluster health: ${statusLabel}`;
  return /* @__PURE__ */ React.createElement(StyledNav, { navbar: true }, /* @__PURE__ */ React.createElement(LinkContainer, { to: overviewWithHealthOn }, /* @__PURE__ */ React.createElement(StyledInactiveNavItem, null, /* @__PURE__ */ React.createElement(
    StyledBadge,
    {
      bsStyle: STATUS_TO_BS_STYLE[overallStatus],
      "data-testid": "health-status-badge",
      title: accessibleLabel,
      "aria-label": accessibleLabel
    },
    /* @__PURE__ */ React.createElement(BadgeIcon, { name: STATUS_TO_ICON[overallStatus], size: "sm" }),
    notificationCount > 0 ? notificationCount : null
  ))));
};
export default HealthStatusBadge;
